import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { subDays, subMonths } from 'date-fns';
import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';
import SimpleChart from 'components/Charts/SimpleChart';
import { jsx as _jsx } from "react/jsx-runtime";
var SparklineWrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'graphStrokeWidth';
  }
}).withConfig({
  displayName: "Sparkline__SparklineWrapper",
  componentId: "sc-1753li0-0"
})([".ct-label.ct-horizontal{color:", ";opacity:1;}svg{overflow:visible;}svg .ct-line{stroke-width:", ";}"], function (p) {
  return p.theme.text;
}, function (p) {
  return p.graphStrokeWidth;
});
function Sparkline(_ref) {
  var data = _ref.data,
    period = _ref.period,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 125 : _ref$height,
    name = _ref.name,
    legend = _ref.legend,
    _ref$graphStrokeWidth = _ref.graphStrokeWidth,
    graphStrokeWidth = _ref$graphStrokeWidth === void 0 ? '2px' : _ref$graphStrokeWidth;
  var count = parseInt(period);
  var isMonthly = count === 365;
  var iterations = isMonthly ? 12 : count;
  var locale = getUsersISOLocale();

  // Full localised date strings used as tooltip labels
  var labels = useMemo(function () {
    var tooltipFmt = new Intl.DateTimeFormat(locale, isMonthly ? {
      month: 'short',
      year: 'numeric'
    } // e.g. "Nov 2025"
    : {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    } // e.g. "1 Nov 2025"
    );
    return Array.from({
      length: iterations
    }).map(function (_, i) {
      var date = isMonthly ? subMonths(new Date(), iterations - 1 - i) : subDays(new Date(), iterations - 1 - i);
      return tooltipFmt.format(date);
    });
  }, [isMonthly, iterations, locale]);

  // Short localised labels for x-axis ticks — derived from index, not by parsing the label string
  var labelInterpolationFnc = useMemo(function () {
    var monthFmt = new Intl.DateTimeFormat(locale, {
      month: 'short'
    });
    var dayFmt = new Intl.DateTimeFormat(locale, {
      day: 'numeric'
    });
    var interval = Math.ceil(iterations / 8);
    return function (_value, index) {
      if (isMonthly) {
        var _date = subMonths(new Date(), iterations - 1 - index);
        return monthFmt.format(_date).charAt(0);
      }
      if (index % interval !== 0) return null;
      var date = subDays(new Date(), iterations - 1 - index);
      return dayFmt.format(date);
    };
  }, [isMonthly, iterations, locale]);
  return /*#__PURE__*/_jsx(SparklineWrapper, {
    graphStrokeWidth: graphStrokeWidth,
    children: /*#__PURE__*/_jsx(SimpleChart, {
      height: height,
      data: data,
      labels: labels,
      name: name,
      showAxisX: true,
      tooltipDistance: 2,
      zeroValueTooltipMinDistance: 18,
      tooltipProps: {
        ignorePointerEvents: true,
        renderInPlace: true,
        variant: 'inverted',
        p: 'xs',
        fontSize: 's',
        as: 'div'
      },
      legend: legend,
      labelInterpolationFnc: labelInterpolationFnc
    })
  });
}
export default Sparkline;